module.exports = __webpack_public_path__ + "img/logo3.de889e1e.png";